import styled from 'styled-components'

export const Body = styled.div`
  align-items: center;
  display: flex;
  height: 300px;
  justify-content: center;
  text-align: center;
`

export const StatusText = styled.div`
  font-size: 20px;
  font-weight: bold;
  padding: 30px;
`
